import styled, { css } from 'styled-components'
import tw from 'twin.macro'
import * as G from '../../../styles/global.styles'
import { colors } from '../../../styles/theme'

export const BannerTitle = styled(G.TextH2)`
  ${tw`mb-1 text-blue__deep font-youfitnessHeading text-xs uppercase font-normal lg:font-bold`}
`

export const Content = styled.h3`
  ${tw`text-black text-3xl font-youfitnessHeading leading-tiny px-4 font-bold uppercase mb-6 leading-10 lg:leading-none`}
`

export const ButtonWrapper = styled.div`
  a {
    ${tw`normal-case text-sm not-italic py-2.5 px-8`}

    @media (max-width: 1023px) {
      ${tw`bg-transparent border border-white hover:bg-white hover:text-blue__deep`}
    }
  }
`

export const Banner = styled.div<{
  bgImage?: string
  useOverlay?: boolean
  overlayColor?: string
}>`
  ${tw`bg-black__deep flex relative overflow-hidden bg-cover bg-no-repeat`}

  ${props =>
    props.bgImage &&
    css`
      background-image: url(${props.bgImage});
    `}

  ${props =>
    props.useOverlay &&
    css`
      &:before {
        content: '';
        width: 100%;
        height: 100%;
        left: 0px;
        top: 0px;
        background: linear-gradient(
            94.67deg,
            rgba(37, 51, 213, 0.9) 1.44%,
            rgba(0, 0, 0, 0) 61.44%
          ),
          linear-gradient(0deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3));
        position: absolute;
      }
    `}

  ${props =>
    props.useOverlay &&
    props.overlayColor &&
    props.overlayColor === 'primary' &&
    css`
      &:before {
        content: '';
        width: 100%;
        height: 100%;
        left: 0px;
        top: 0px;
        background: linear-gradient(
            94.67deg,
            rgba(238, 108, 22, 0.9) 1.44%,
            rgba(0, 0, 0, 0) 61.44%
          ),
          linear-gradient(0deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3));
        position: absolute;
      }
    `}
`

export const BannerImage = styled.div<{
  bgImage?: string
  imagePosition?: string
}>`
  flex: 0 0 55%;
  img {
    ${tw`h-full object-cover opacity-0 h-0`}
  }

  ${props =>
    props.bgImage &&
    css`
      ${tw`bg-cover`}
      background-image: url(${props.bgImage});
      background-position: ${props.imagePosition || 'center'};
    `}

  @media (max-width: 1023px) {
    ${tw`hidden`}
  }
`

export const BannerInfo = styled.div<{ triangleHeight?: number }>`
  ${tw`bg-white__deep text-center py-7 lg:py-12.5 flex-1 relative px-4 lg:pr-5 lg:pl-0 flex items-center flex-col justify-center`}

  @media (max-width: 1023px) {
    ${tw`w-full bg-transparent`}

    ${Content},
    ${BannerTitle} {
      ${tw`text-white`}
    }
  }

  &:before {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    right: 100%;
    top: -2px;
    border-style: solid;
    border-width: ${({ triangleHeight }) => triangleHeight}px 120px 0px 0px;
    border-color: transparent ${colors.white__deep} transparent transparent;
    z-index: 5;
  }
`

export const Section = styled.div<{ noPadding?: boolean }>`
  ${props => (props.noPadding ? tw`py-0` : tw`pb-20`)}
  ${tw`bg-black__deep w-full`}
`
